import { InvitedUser, UserReadAll } from "store/api/generatedApi";

export type UserRow = UserReadAll & { id: string };
export type InviteRow = InvitedUser & { id: string };

export type UserDrawerTarget =
  { kind: "user"; user: UserReadAll } | { kind: "invite"; invite: InvitedUser };

export type QuickFilterKey = "admins" | "disabled" | "noPermissions";

const matchesSearch = (fields: string[], search: string): boolean => {
  const query = search.trim().toLowerCase();
  if (query === "") return true;
  return fields.some((field) => field.toLowerCase().includes(query));
};

export const filterUsers = (
  users: UserRow[],
  search: string,
  quickFilters: ReadonlySet<QuickFilterKey>
): UserRow[] =>
  users.filter((user) => {
    if (!matchesSearch([user.name, user.email], search)) return false;
    if (quickFilters.has("admins") && !user.is_admin) return false;
    if (quickFilters.has("disabled") && user.is_enabled) return false;
    if (quickFilters.has("noPermissions") && user.permissions.length > 0)
      return false;
    return true;
  });

export const filterInvites = (
  invites: InviteRow[],
  search: string
): InviteRow[] =>
  invites.filter((invite) => matchesSearch([invite.email], search));
